import helpers from '@/services/helpers';

const mixin = {
  methods: {
    formatDate: helpers.formatDate,
  },
};

export default mixin;